import React from "react";
import { Link } from "react-router-dom";
import { replaceStaticHost } from "Helpers/ImageManager";
import withStyles from "react-jss";

const styles = theme => {
    return {
        root: {
            width: "100%",
            "& a": {
                display: "inline-block",
                width: "65%",
                height: "40px",
            },
            "& embed": {
                width: "100%",
                height: "40px",
                pointerEvents: "none",
            },
        },
        [`@media (max-width: ${theme.media.lg})`]: {
            root: {
                display: "none",
            },
        },
        // [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
        //     root: {
        //         "& a": {
        //             width: "90%",
        //         },
        //         "& embed": {
        //             width: "100%",
        //             marginTop: "-8px",
        //         },
        //     },
        // },
        // [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        //     root: {
        //         width: "auto",
        //         display: "flex",
        //         justifyContent: "center",
        //         "& a": {
        //             width: "auto",
        //             height: "35px",
        //         },
        //         "& embed": {
        //             width: "auto",
        //             marginTop: "0",
        //             height: "35px",
        //         },
        //     },
        // },
    };
};

class MenuItemMain extends React.Component {
    static defaultProps = {
        url: "",
        onClickLogo: () => {},
        datatest: null,
    };

    render() {
        let classes = this.props.classes;
        return (
            <div className={classes.root} onClick={this.props.onClickLogo}>
                <Link
                    aria-label={this.props.url}
                    to={this.props.url}
                    datatest={this.props.datatest}
                >
                    <embed src={replaceStaticHost(this.props.logo)} />
                </Link>
            </div>
        );
    }
}

export default withStyles(styles)(MenuItemMain);
